import { ResourceApi } from 'services/api'
import { Canje } from './Canje'

export class CanjeApi extends ResourceApi<Canje> {
  constructor(tituloId: Identifier) {
    super('/api/titulos/:tituloId/canjes', { tituloId })
  }
}
